import React, { forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { GenericSettingsPane, GenericSettingsPaneHandle } from './GenericSettingsPane';
import { PaneHandle, PaneProps } from '../accountParameter.types';
import { useStoreState } from '../../../../models/hooks';
import { useTranslation } from 'react-i18next';

export const OfferPane = forwardRef<PaneHandle, PaneProps>(({ onSave, setDirty, showActions }, ref) => {
  const genericPaneRef = useRef<GenericSettingsPaneHandle>(null);
  const account = useStoreState((state) => state.app.accounts);
  const { t } = useTranslation('accountParameter');

  useImperativeHandle(ref, () => ({
    save: () => genericPaneRef.current?.save(),
    reset: () => genericPaneRef.current?.reset(),
  }));

  const memoizedItems = useMemo(
    () => [
      {
        key: 'effectiveDateInDays',
        label: t('offerPane.startDateWindow'),
        description: t('offerPane.startDateWindowDescription'),
        value: account?.configuration?.effectiveDateInDays ?? 28,
        type: 'number' as const,
        unit: t('offerPane.days'),
        min: 1,
        max: 28,
        isRequired: true,
      },
      {
        key: 'offerAcceptancePeriod',
        label: t('offerPane.offerAcceptancePeriod'),
        description: t('offerPane.offerAcceptancePeriodDescription'),
        value: account?.configuration?.offerAcceptancePeriod,
        unit: t('offerPane.days'),
        min: 1,
        max: 28,
        type: 'number' as const,
        isRequired: true,
      },
    ],
    [account, t],
  );

  return (
    <GenericSettingsPane
      ref={genericPaneRef}
      onSave={onSave}
      setDirty={setDirty}
      showInlineActions={showActions}
      items={memoizedItems}
    />
  );
});
